import { commons } from '@provise/lib/transformer'

export function complaintLabel(cmpl) {
  let l = []
  if (cmpl.request_category) {
    l = [cmpl.request_category.name]
  }
  l = [...l, commons.medicineLabel(cmpl.medicine), commons.dateLocal(cmpl.date_created, 'P')]
  return l.join(', ')
}
